import {
  resourceCategoryFormData,
  resourceFormData,
  resourceSubCategoryFormData,
} from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllCategories = (
  // page: number,
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/categories?sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const getCategoryById = (
  id: string,
  sortBy: string,
  sortOrderValue: string,
  schoolId: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/categories/${id}/categories?sortBy=${sortBy}&sortOrder=${sortOrderValue}&school=${schoolId}`
  )
}
export const getCategoriesNameById = (
  id: string,
  schoolId: string
): Promise<unknown> => {
  return get(`${BASE_URL}/categories/${id}/categories?school=${schoolId}`)
}

export const createCategory = (
  data: resourceCategoryFormData
): Promise<unknown> => {
  return post(`${BASE_URL}/categories`, data, null)
}

export const createSubCategory = (
  data: resourceSubCategoryFormData
): Promise<unknown> => {
  return post(`${BASE_URL}/categories`, data, null)
}

export const updateCategory = (
  data: resourceCategoryFormData,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/categories/${id}`, data, null)
}

export const deleteCategory = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/categories/${id}`, null)
}

export const createResource = (
  data: resourceFormData,
  id: string
): Promise<unknown> => {
  return post(
    `${BASE_URL}/categories/${id}/resources`,
    {
      resources: [data],
    },
    null
  )
}

export const getResourcesById = (
  id: string,
  schoolId: string,
  page: number,
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  return get(
    `${BASE_URL}/categories/${id}/resources?school=${schoolId}&page=${page}&sortBy=${sortBy}&sortOrder=${sortOrderValue}`
  )
}

export const deleteCategoryResource = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/categories/resources/${id}`, null)
}
